module.exports = __webpack_public_path__ + "static/PlaceIt-e302d4a8603791a55720852eeb43a513.png";